"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationsWebStorage = void 0;
const core_1 = require("../../core");
const biggestStorage_1 = require("../../store/biggestStorage");
const translationsVersion_1 = require("../translationsVersion");
const TRANSLATIONS_KEY = 'translations';
const getVersion = (translations) => ({
    language: translations.language,
    version: translations.version,
});
const LOG_PREFIX = '[Web Storage]';
class TranslationsWebStorage {
    constructor({ platform }) {
        this.storage = new biggestStorage_1.BiggestStorage({
            prefix: platform,
        });
        this.storedVersion = undefined;
        this.onSync = false;
    }
    set(translations) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.storage.setItem(TRANSLATIONS_KEY, translations);
                this.storedVersion = getVersion(translations);
                core_1.Log.info(LOG_PREFIX + ' - set new version of translations');
                return Promise.resolve();
            }
            catch (e) {
                core_1.Log.warn(LOG_PREFIX + ' - error setting translations');
                return Promise.reject(e);
            }
        });
    }
    remove() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.storage.removeItem(TRANSLATIONS_KEY);
                core_1.Log.info(LOG_PREFIX + ' - removing translations');
                return Promise.resolve();
            }
            catch (e) {
                core_1.Log.warn(LOG_PREFIX + ' - error removing translations');
                return Promise.reject(e);
            }
        });
    }
    isEmpty() {
        return this.storedVersion === undefined;
    }
    sync(expectedStoredVersion) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!this.onSync) {
                    const storedTranslations = yield this.get();
                    if (storedTranslations !== undefined) {
                        const storedVersion = getVersion(storedTranslations);
                        if (translationsVersion_1.TranslationsVersion.isCompatibleWith(storedVersion, expectedStoredVersion)) {
                            this.storedVersion = storedVersion;
                            core_1.Log.info(LOG_PREFIX + ' - sync - loading stored version');
                        }
                        else {
                            core_1.Log.info(LOG_PREFIX + ' - sync - removing stored version, looks like that is incompatible with the expected one');
                            yield this.remove();
                        }
                    }
                    else {
                        core_1.Log.info(LOG_PREFIX + ' - sync - looks like that is the first time to use this storage');
                    }
                    this.onSync = true;
                }
                return Promise.resolve();
            }
            catch (e) {
                core_1.Log.warn(LOG_PREFIX + ' - sync - error trying to sync storage');
                return Promise.reject(e);
            }
        });
    }
    get() {
        return __awaiter(this, void 0, void 0, function* () {
            core_1.Log.info(LOG_PREFIX + ' - get - getting stored version');
            return this.storage.getItem(TRANSLATIONS_KEY);
        });
    }
    getVersion() {
        return this.storedVersion;
    }
    update(newTranslations) {
        return __awaiter(this, void 0, void 0, function* () {
            const storedTranslations = yield this.get();
            if (storedTranslations !== undefined) {
                core_1.Log.info(LOG_PREFIX + ' - update - updating stored version as a new version');
                return yield this.set((0, core_1.mergeDeep)(storedTranslations, newTranslations));
            }
            return yield this.set(newTranslations);
        });
    }
}
exports.TranslationsWebStorage = TranslationsWebStorage;
//# sourceMappingURL=translationsWebStorage.js.map